/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "face-sad-99a5333b--sprite",
  "use": "face-sad-99a5333b--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"face-sad-99a5333b--sprite\"><g transform=\"translate(-115.691 -9.732)\"><path d=\"M138.609,19.026a10,10,0,1,0-6.866,18.528,10.337,10.337,0,0,0,1.922.178h.053a10.337,10.337,0,0,0,1.922-.178,10.009,10.009,0,0,0,2.969-18.528Zm-9.325,8.468a1.1,1.1,0,0,1,.009-2.206A1.114,1.114,0,0,1,130.4,26.4a1.093,1.093,0,0,1-.138.529,1.056,1.056,0,0,1-.959.565Zm.91,4.843a8.741,8.741,0,0,1,1.726-.511,9.363,9.363,0,0,1,3.542,0,8.743,8.743,0,0,1,1.727.511.55.55,0,0,1-.391,1.027c-.009,0-.022,0-.031-.009a7.13,7.13,0,0,0-1.5-.445,8.239,8.239,0,0,0-3.142,0,7.131,7.131,0,0,0-1.5.445c-.009,0-.022,0-.031.009a.55.55,0,0,1-.391-1.027Zm7.9-4.843-.018,0a1.056,1.056,0,0,1-.959-.565,1.093,1.093,0,0,1-.138-.529,1.094,1.094,0,1,1,2.188-.036A1.1,1.1,0,0,1,138.1,27.494Z\" transform=\"translate(0)\" fill=\"currentColor\" /></g><rect width=\"36\" height=\"36\" fill=\"none\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
